import { useCallback } from 'react'
import ModalDeleteFilled from '../../../../../../baseComponents/ModalsLayouts/ModalDeleteFilled'
import { twinFetchPostJSON } from '../../../../../../utils/globals/data'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import { RowData, TableData } from '../../../../../../baseComponents/TwinTable/types'
import { SetEditDeleteModalTy } from '../../../../../../utils/hooks/useEditDeleteModal'

interface ModalDeleteWorkSheetProductProps extends ModalDeleteWorkSheetProductLogicProps {
    setOpenModal: SetEditDeleteModalTy
}

const ModalDeleteWorkSheetProduct: React.FC<ModalDeleteWorkSheetProductProps> = ({ setOpenModal, ...rest }) => {
    const { t } = useTwinTranslation()
    const { handleDelete } = useModalDeleteWorkSheetProductLogic({...rest})
    return (
        <ModalDeleteFilled opened={true} setOpened={() =>setOpenModal(null)} onCancel={() => setOpenModal(null)} onAccept={handleDelete} translations={{
            title: t('sureDeleteLine', '¿Seguro quieres eliminar esta línea?'),
            subtitle: t('onceDeletedNotRecover', 'Una vez eliminada no podrás recuperarla')
        }} />
    )
}

interface ModalDeleteWorkSheetProductLogicProps {
    deleteURL: string
    allRowData: RowData
    getCompleteData: (inputtable?: TableData) => Promise<void>
}

const useModalDeleteWorkSheetProductLogic = ({ deleteURL, allRowData, getCompleteData }: ModalDeleteWorkSheetProductLogicProps) => {
     const handleDelete = useCallback(async () => {
         const result = await twinFetchPostJSON(deleteURL, { id: allRowData.id, WorkSheetId: allRowData.WorkSheetId, nLine: allRowData.nLine })
        if (result) {
            getCompleteData()
            return true
        }
    }, [allRowData, deleteURL, getCompleteData])
    return { handleDelete }
}

export default ModalDeleteWorkSheetProduct